import React, { memo, useEffect, useRef, useState } from "react";
import Header from "../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import { getPromotion, postProduct, updateProductData, } from "../../../services/auth";
import { decrypt } from "../../../utils/encodingdecoding";
import swal from "sweetalert";
import CustomPagination from "../../partial/CustomPagination"
import { fileUpload } from "../../../services/services";
import { Modal } from "react-bootstrap";

const ProductManagement = () => {
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState({
        file: "",
        error: true,
        errorMsg: "Note:- Only .csv type files are supported.",
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [response, setResponse] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [editData, setEditData] = useState({});
    const [uploadRowId, setUploadRowId] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [modalImage, setModalImage] = useState(null);


    const { file, error, errorMsg } = state;
    const pageSize = 10;
    const pageCount = Math.ceil(response?.length / pageSize);

    const fileInputRef = useRef(null);

    const onChange = (e) => {
        if (e.target.files[0]?.type?.includes("csv")) {
            setState({ ...state, file: e.target.files[0], error: false });
        } else {
            setState({ ...state, error: true });
        }
    };

    const fetchOffer = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = decrypt(localStorage.getItem("Id"));
        try {
            const res = await getPromotion(token?.access_token, Id);
            setResponse(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchOffer();
    }, []);

    const onSubmit = async () => {
        if (file) {
            const token = JSON.parse(localStorage.getItem("token_gen"));
            const Id = decrypt(localStorage.getItem("Id"));
            setLoader(true);
            try {
                await postProduct(file, token?.access_token, Id).then((res) => {
                    if (res.message == "Success") {
                        fileInputRef.current.value = "";
                        setState({
                            file: "",
                            error: false,
                            errorMsg: "Note:- Only .csv type files are supported.",
                        });
                        fetchOffer();
                        swal({
                            position: "center",
                            icon: "success",
                            title: "Product uploaded successfully",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        swal({
                            position: "center",
                            icon: "error",
                            title: "Product not uploaded ",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })

            } catch (err) {
                console.error(err);
            } finally {
                setLoader(false);
            }
        } else {
            setState({ ...state, error: true, errorMsg: "Please upload a file" });
        }
    };

    const handleEdit = (id) => {
        const data = response.find((item) => item.id === id);
        setEditRowId(id);
        setEditData(data);
    };

    const handleInputChange = (key, value) => {
        setEditData((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        try {
            await updateProductData(token?.access_token, editRowId, editData,).then((res) => {
                if (res.message == "Success") {
                    setEditRowId(null);
                    setLoader(false)
                    swal({
                        position: "center",
                        icon: "success",
                        title: "Product data updated successfully",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    fetchOffer();
                }
                else {
                    swal({
                        position: "center",
                        icon: "error",
                        title: "Product data not updated",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            })

        } catch (err) {
            console.error(err);

        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB"); // DD-MM-YYYY
    };
    const handleCancel = () => {
        setEditRowId(null);
        setEditData({});
    };

    const handleUploadImage = (id) => {
        const data = response.find((item) => item.id === id);
        setEditData(data);
        setUploadRowId(id);
        setImageFile(null);
        setPreviewImage(null);
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 50 * 1024 * 1024) {
            swal({
                position: "center",
                icon: "error",
                title: "File too large!",
                text: "Image size must be less than 50MB.",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        if (!file.type.startsWith("image/")) {
            swal({
                position: "center",
                icon: "warning",
                title: "Only image files allowed!",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        setImageFile(file);
        setPreviewImage(URL.createObjectURL(file));
    };

    const saveImage = async () => {
        if (!imageFile) {
            swal({
                position: "center",
                icon: "warning",
                title: "Please select an image first!",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }
        const token = JSON.parse(localStorage.getItem("token_gen"));

        try {
            setLoader(true)
            const fileRes = await fileUpload(token?.access_token, imageFile);
            if (fileRes.message === "success") {
                const body = { ...editData, product_Image: fileRes?.data?.blobFilePath }
                const res = await updateProductData(token?.access_token, uploadRowId, body);
                if (res.message == "Success") {
                    setEditData(null);
                    setUploadRowId(null);
                    setImageFile(null);
                    setPreviewImage(null);
                    setLoader(false)
                    swal({
                        position: "center",
                        icon: "success",
                        title: "Image uploaded successfully",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                } else {
                    swal({
                        position: "center",
                        icon: "error",
                        title: "Image not uploaded",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            }
        } catch (err) {
            swal({
                position: "center",
                icon: "error",
                title: "Image not uploaded",
                showConfirmButton: false,
                timer: 3000,
            });
        }
    };


    return (
        <>
            <Header name={"Product Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        {[...Array(8)].map((_, i) => (
                            <div key={i}></div>
                        ))}
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <ValidatorForm onSubmit={onSubmit} className="dashboard__customerViewMain">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Upload Product</h4>
                            </div>
                        </div>
                        <div className='dashboard__customerViewCard'>
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="uploadingExistingData__uploadBoxUploadFile">
                                        <form encType="multipart/form-data">
                                            <input
                                                ref={fileInputRef}
                                                className="form-control"
                                                placeholder="Uploaded File"
                                                type="file"
                                                accept=".csv"
                                                onChange={onChange}
                                            />
                                            {error && <span className="text-danger">{errorMsg}</span>}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='customer_group_form'>
                                <button type='submit' className="btn btn-primary">
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </ValidatorForm>

                <div className="dashboard__customersCard">
                    <div className="dashboard__header">
                        <div className="dashboard__left">
                            <h4>Product List</h4>
                        </div>
                    </div>
                    <div className="dashboard__body">
                        {Array.isArray(response) && response.length > 0 ? (
                            <div>
                                <div className="cp-table-wrapper">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>product_Name</th>
                                                {Object.keys(response[0])
                                                    .filter(
                                                        (key) =>
                                                            ![
                                                                "merchantCode",
                                                                "createdAt",
                                                                "discriminator",
                                                                "productMasterFile",
                                                                "product_Image",
                                                                "updatedAt",
                                                                "_rid",
                                                                "_self",
                                                                "_etag",
                                                                "_attachments",
                                                                "_ts",
                                                                "id",
                                                                "product_Name",
                                                                "product_Image"
                                                            ].includes(key)
                                                    )
                                                    .map((key) => (
                                                        <th key={key}>{key}</th>
                                                    ))}
                                                <th className="position-sticky-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {response
                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                .map((item) => (
                                                    <tr key={item.id}>
                                                        <td className="product-name-column">
                                                            <div className="d-flex align-items-center gap-1">
                                                                {item.product_Image && <i
                                                                    className="fa-solid fa-image fa-1x text-primary cursor-pointer"
                                                                    onClick={() => {
                                                                        setModalImage(item.product_Image);
                                                                        setModalShow(true);
                                                                    }
                                                                    }
                                                                ></i>}
                                                                <span className="fw-medium text-center">{item.product_Name}</span>
                                                            </div>
                                                        </td>
                                                        {Object.entries(item)
                                                            .filter(
                                                                ([key]) =>
                                                                    ![
                                                                        "merchantCode",
                                                                        "createdAt",
                                                                        "discriminator",
                                                                        "productMasterFile",
                                                                        "updatedAt",
                                                                        "_rid",
                                                                        "_self",
                                                                        "_etag",
                                                                        "_attachments",
                                                                        "_ts",
                                                                        "id",
                                                                        "product_Name",
                                                                        "product_Image"
                                                                    ].includes(key)
                                                            )
                                                            .map(([key, value]) => (
                                                                <td key={key} className={key === "product_Name" ? "product-name" : ""}>
                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                        <input
                                                                            className="editData"
                                                                            value={editData[key] || ""}
                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                        />
                                                                    ) : key === "createdAt" ? (
                                                                        formatDate(value)
                                                                    ) : typeof value === "object" && value !== null ? (
                                                                        JSON.stringify(value)
                                                                    ) : (
                                                                        value
                                                                    )}
                                                                </td>
                                                            ))}

                                                        <td className="sticky-action">
                                                            {editRowId === item.id ? (
                                                                <div className="flex-center">
                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                        Save
                                                                    </button>
                                                                    <button className="btn btn-sm btn-secondary ms-1" onClick={handleCancel}>
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            ) : uploadRowId === item.id ? (
                                                                <div className="upload-box">
                                                                    <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        className="form-control form-control-sm"
                                                                        onChange={handleFileSelect}
                                                                    />

                                                                    {previewImage && <img src={previewImage} alt="preview" className="img-preview" />}

                                                                    <div className="d-flex gap-3 justify-content-center">
                                                                        <button className="btn btn-success" onClick={saveImage}>
                                                                            Upload
                                                                        </button>

                                                                        <button className="btn btn-secondary" onClick={() => setUploadRowId(null)}>
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                            ) : (
                                                                <div className="flex-center">
                                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(item.id)}>
                                                                        Edit
                                                                    </button>

                                                                    <button className="btn btn-sm btn-outline-success" onClick={() => handleUploadImage(item.id)}>
                                                                        <i className="fa-solid fa-image"></i> Upload
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="dashboard__paginationBox mt-2">
                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                </div>
                            </div>
                        ) : (
                            <p className="text-center">No data found</p>
                        )}
                    </div>
                </div>
            </div>
            <Modal show={modalShow} onHide={() => {
                setModalShow(false);
                setModalImage(null);
            }} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Product Image</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex justify-content-center">
                    <img src={modalImage} alt="Product" className="img-fluid" />
                </Modal.Body>
            </Modal>;
        </>
    );
};

export default ProductManagement;